import styled from 'styled-components'

export const Container = styled.span<{ lineHeight?: string }>`
  line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '1.6')};
`
type HighlightProps = {
  color?: string
  transparent?: boolean
  backgroundColor?: string
}
export const Highlight = styled.span<HighlightProps>`
  display: inline;
  padding: 0.1em 0.2em;
  box-decoration-break: clone;
  color: ${({ color, theme }) => (color ? color : theme.colors.pureBlack)};
  background-color: ${({ theme, transparent, backgroundColor }) =>
    transparent
      ? theme.colors.pureWhite80
      : backgroundColor
      ? backgroundColor
      : theme.colors.pureWhite};

  & br {
    display: block !important;
  }
`
